// extracted by mini-css-extract-plugin
export default {"shareButton":"styles-module__pk2me","shareIcon":"styles-module__MYSD8","iconOnly":"styles-module__RyAdE"};